import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectOtpCode = (store: StoreSchema) => store.loginState.otpCode